import { ObjectWithAnyValues } from "utils/types";
import { BaseModel } from "../BaseModel";
import { BackofficeUserProps } from "./types";

export class BackofficeUser extends BaseModel {
	name: string;
	email: string;

	constructor(data: BackofficeUserProps) {
		super(data);
		this.name = data.name;
		this.email = data.email;
	}

	static createFromResponse(response: ObjectWithAnyValues, Model: any = this) {
		if (!response) {
			return response;
		}

		return new Model({ ...response });
	}
}
